import * as React from 'react';
import {graphql, useStaticQuery} from 'gatsby';
import {GatsbyImage, IGatsbyImageData} from 'gatsby-plugin-image';
import {Link} from '../../components/common';
import aotd from '../../images/app-ot-day-light.png';
import playStore from '../../images/play-badge-1.png';
import appStore from '../../images/app-badge-1.png';
import {appStoreLink, playStoreLink} from '../../constants';
import {ButtonTracking} from '../../types';

export const MarketingCard = ({tagline}: {tagline: string}) => {
  const data = useStaticQuery<Queries.MarketingCardImageQuery>(graphql`
    query MarketingCardImage {
      file(relativePath: {eq: "homepage/marketing-card.png"}) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, placeholder: NONE, quality: 90)
        }
      }
    }
  `);
  const marketingCardImage = data.file?.childImageSharp
    ?.gatsbyImageData as unknown as IGatsbyImageData;

  return (
    <div className="relative h-full flex justify-center items-center rounded-[2rem] max-w-full overflow-hidden">
      <GatsbyImage
        image={marketingCardImage}
        alt=""
        objectFit="cover"
        style={{position: 'absolute', inset: 0}}
      />
      <div className="relative w-[80%] text-center lg:text-left">
        <img
          src={aotd}
          alt="apple's app of the day logo"
          className="m-auto lg:m-0"
        />
        <h4 className="text-white text-h3mob lg:text-h3 font-semibold pt-4 pb-5">
          {tagline}
        </h4>
        <div className="flex gap-4 pt-4 lg:pt-6 justify-center lg:justify-start h-[4rem] lg:h-[5rem]">
          <Link
            href={appStoreLink}
            external
            tracking={ButtonTracking.AppStoreDownload}>
            <img
              src={appStore}
              className="hover:opacity-90 max-h-[100%]"
              alt="Apple app store button"
            />
          </Link>
          <Link
            href={playStoreLink}
            external
            tracking={ButtonTracking.AppStoreDownload}>
            <img
              src={playStore}
              className="hover:opacity-90 max-h-[100%]"
              alt="Google play store button"
            />
          </Link>
        </div>
      </div>
    </div>
  );
};
